<template>
  <div class="time-place" :class="{ 'radar-size': this.size === 'radar-size' }">
    <div class="time">{{ currentTime }}</div>
    <div class="position-date-place">
      <div class="position">{{ bridgeName }}</div>
      <div class="date">{{ currentDate }}</div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'TimeBlock',
  props: ['bridgeName', 'size'],
  data() {
    return {
      currentTime: '',
      currentDate: '',
      currentTimer: null
    }
  },
  beforeDestroy() {
    clearInterval(this.currentTimer)
  },
  mounted() {
    this.updateCurrentTime()
    this.updateCurrenDate()
    this.currentTimer = setInterval(() => {
      this.updateCurrentTime()
      this.updateCurrenDate()
    }, 30000)
  },
  methods: {
    updateCurrentTime() {
      this.currentTime = dayjs().format('HH:mm')
    },
    updateCurrenDate() {
      this.currentDate = dayjs().format('MMM DD.YYYY')
    }
  }
}
</script>
<style lang="scss" scoped>
.time-place {
  height: 95px;
  width: 150px;
  color: #fff;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.3);
  filter: opacity(30);
  text-align: center;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  align-items: center;

  div {
    text-shadow: 1px 2px 2px #bdb8b8;
  }

  &.radar-size {
    height: 170px;
    width: 240px;
    background: rgba(255, 255, 255, 0.45);
  }

  .time {
    padding: 5px;
    font-size: 40px;
    font-weight: 100;
  }

  .position {
    font-size: 17px;
  }
}
</style>
